import { useCompany } from "Components/Company/hooks/useCompany";
import { useCompanySetting } from "Components/CompanySetting/hooks/useCompanySetting";
import { useProfile } from "Components/Profile/hooks/useProfile";

export const useAuthDocsError = () => {
	const profileError = useProfile((state) => state.error);
	const companyError = useCompany((state) => state.error);
	const companySettingError = useCompanySetting((state) => state.error);

	return profileError || companyError || companySettingError;
};
